import React, { FC, memo, useState } from 'react';
import KeyIcon from '~Assets/icons/key_vertical.svg';
import Icon from '~ComponentsImproved/Icon';
import NumberInput from '~ComponentsImproved/Numpad';
import { useButton, useI18n } from '~Hooks';
import { GrayButton } from '~Styles';

interface Props {
  isHandy: boolean;
  /** Called with whatever was typed in the numpad; the parent decides if it is valid */
  onSubmit: (code: string) => void;
}

/** Icon-only key button that opens a numpad asking for the operational access code */
const OperationalAccessButton: FC<Props> = ({ isHandy, onSubmit }) => {
  const { i18n } = useI18n();
  const [open, setOpen] = useState(false);

  const openButton = useButton({ onClick: () => setOpen(true) });

  const submit = (code: string) => {
    setOpen(false);
    onSubmit(code);
  };

  return (
    <>
      <GrayButton {...openButton} size={isHandy ? 'medium' : 'large'}>
        <Icon src={KeyIcon} color="var(--colorBlueGray200)" height="24px" width="24px" />
      </GrayButton>

      {open && (
        <NumberInput
          title={i18n('Settings.Blueprints.Access.Title')}
          initialValue="0000"
          initialValueIsPlaceholder
          maxCount={8}
          onSubmit={submit}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default memo(OperationalAccessButton);
